import { render, staticRenderFns } from "./UpgradesGraph.vue?vue&type=template&id=28853132&"
import script from "./UpgradesGraph.vue?vue&type=script&lang=js&"
export * from "./UpgradesGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports